import './notfound.scss';
import Inelogo from '../../Utils/img/ine_white.svg';

function Content404() {
    return(
        <>
            <div className="np404">
                <div className="np404__content">
                    {/* <img className='np404__content--img' src={Inelogo} alt="INE Logotipo"></img> */}
                    <h1 className='np404__content--404'>404</h1>
                    <h1 className='np404__content--title'>Busqueda no disponible</h1>
                </div>
            </div>
        </>
    );
};

export default Content404;